import { render } from "./ChatbotList.vue?vue&type=template&id=3bad2185&scoped=true"
import script from "./ChatbotList.vue?vue&type=script&lang=js"
export * from "./ChatbotList.vue?vue&type=script&lang=js"

import "./ChatbotList.vue?vue&type=style&index=0&id=3bad2185&scoped=true&lang=css"

import exportComponent from "../../../peelochat-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bad2185"]])

export default __exports__